(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2749],{

/***/ 62421:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client-opd",
      function () {
        return __webpack_require__(13048);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PatientBillView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90759);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74107);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _inventory_billing_BillView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61192);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);








var PatientBillView = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), billId = ref1[0], setBillId = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), customerId = ref2[0], setCustomerId = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), customerData = ref3[0], setCustomerData = ref3[1];
    var handlePostAction = function(billId) {
        axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/backend/customer/data/save/" + props.uhid + "/" + props.qrCode + "?qId=" + props.qId, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, customerData), {
            billId: billId
        })).then(function(resp) {
            console.info(JSON.parse(resp.data));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (props.qrCode && props.uhid) {
            if (props.qId) {
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customer/data/fetch/" + props.uhid + "/" + props.qId).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setBillId(resp.data.billId);
                    setCustomerData(resp.data);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                });
            } else {
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customer/data/fetch/latest/" + props.qrCode + "/" + props.uhid).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setBillId(resp.data.billId);
                    setCustomerData(resp.data);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                });
            }
            axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customers/fetch/" + props.uhid).then(function(resp1) {
                console.log(JSON.stringify(resp1.data));
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/inventory/customer/fetch/" + props.entityQr + "?name=" + resp1.data.name + "&contact=" + resp1.data.mobile).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setCustomerId(resp.data.id);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                    axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/backend/inventory/customer/create", {
                        entityQr: props.entityQr,
                        type: "INDIVIDUAL",
                        name: resp1.data.name,
                        displayName: resp1.data.name,
                        contact1: resp1.data.mobile
                    }).then(function(resp) {
                        console.log(JSON.stringify(resp.data));
                        setCustomerId(resp.data.id);
                    }).catch(function(err) {
                        console.error(err);
                        if (err.response && err.response.status && err.response.status === 403) {
                            (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                        }
                    });
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                }
            });
        }
    }, [
        props.qrCode,
        props.uhid
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: customerId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_inventory_billing_BillView__WEBPACK_IMPORTED_MODULE_4__/* .BillView */ .k, {
            billId: billId,
            customerId: customerId,
            entityQr: props.entityQr,
            postAction: handlePostAction,
            source: "OPD"
        })
    });
});
PatientBillView.displayName = "PatientBillView";


/***/ }),

/***/ 13048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ client_opd; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 1 modules
var Nav = __webpack_require__(88819);
// EXTERNAL MODULE: ./components/client/FutureBookingCalenderView.tsx + 1 modules
var FutureBookingCalenderView = __webpack_require__(89396);
// EXTERNAL MODULE: ./components/client/reports/ReportsView.tsx
var ReportsView = __webpack_require__(49544);
// EXTERNAL MODULE: ./components/entity/opd/entityCustomer/EntityCustomerView.tsx + 2 modules
var EntityCustomerView = __webpack_require__(67334);
;// CONCATENATED MODULE: ./components/client/self/ClientIndependentOpdView.tsx










var ClientIndependentOpdView = function(props) {
    var ref = (0,react.useState)([]), doctors = ref[0], setDoctors = ref[1];
    var ref1 = (0,react.useState)(), qmeEnabled = ref1[0], setQmeEnabled = ref1[1];
    var ref2 = (0,react.useState)(), entityQr = ref2[0], setEntityQr = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 1), cookies = ref3[0];
    var ref4 = (0,react.useState)(false), futureEnabled = ref4[0], setFutureEnabled = ref4[1];
    var ref5 = (0,react.useState)(false), opd = ref5[0], setOpd = ref5[1];
    (0,react.useEffect)(function() {
        // Perform localStorage action
        setOpd(localStorage.getItem("opd") == "true");
    }, []);
    (0,react.useEffect)(function() {
        if (props.cookieQr) {
            axios_default().get("/api/backend/user/client/profile?qrCode=" + props.cookieQr).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setEntityQr(resp.data.client.entityQrCode);
                axios_default().get("/api/backend/entity/profile/" + resp.data.client.entityQrCode).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setQmeEnabled(resp.data.qmeEnabled);
                    var docs = resp.data.clientProfileEntities.filter(function(cp) {
                        return cp.qrCode == props.cookieQr;
                    });
                    setDoctors(docs);
                    docs.map(function(profile) {
                        axios_default().get("/api/backend/client/config/fetch/" + profile.qrCode).then(function(resp) {
                            if (resp.data) {
                                setFutureEnabled(function(flag) {
                                    return flag || resp.data.futureAppointments;
                                });
                            }
                        }).catch(function(err) {
                            console.error(err);
                            if (err.response && err.response.status && err.response.status === 403) {
                                (0,utils/* handleLogout */.hY)();
                            }
                        }).finally(function() {});
                    });
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {});
            axios_default().get("/api/backend/client/config/fetch/" + props.cookieQr).then(function(resp) {
                if (resp.data) {
                    setFutureEnabled(resp.data.futureEnabled);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {});
        }
    }, [
        props.cookieQr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-lg-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                    defaultActiveKey: !opd ? "patients" : "future",
                    className: "my-3 fs-6 text-secondary nav-pills",
                    children: [
                        futureEnabled && opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "future",
                            title: "\uD83D\uDCC5 Appointments",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FutureBookingCalenderView/* FutureBookingCalenderView */.s, {
                                doctors: doctors
                            })
                        }),
                        opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "manage",
                            title: "\uD83D\uDCC1 Reports",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportsView/* ReportsView */.E, {
                                doctors: doctors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                            eventKey: "patients",
                            title: "\uD83D\uDD0D Search",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityCustomerView/* EntityCustomerView */.I, {
                                cookieEntityQr: entityQr
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row d-none d-lg-block left-tabs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default.Container */.Z.Container, {
                        id: "left-tabs",
                        defaultActiveKey: !opd ? "patients" : "future",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "justify-content-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    sm: 2,
                                    className: "sidebar-menu",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                                        variant: "pills",
                                        className: "flex-column",
                                        children: [
                                            futureEnabled && opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                    eventKey: "future",
                                                    children: "Appointments"
                                                })
                                            }),
                                            opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                    eventKey: "manage",
                                                    children: "Reports"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                    eventKey: "patients",
                                                    children: "Search"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    sm: 10,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* default.Content */.Z.Content, {
                                        children: [
                                            futureEnabled && opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default.Pane */.Z.Pane, {
                                                eventKey: "future",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FutureBookingCalenderView/* FutureBookingCalenderView */.s, {
                                                    doctors: doctors
                                                })
                                            }),
                                            opd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default.Pane */.Z.Pane, {
                                                eventKey: "manage",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportsView/* ReportsView */.E, {
                                                    doctors: doctors
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default.Pane */.Z.Pane, {
                                                eventKey: "patients",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityCustomerView/* EntityCustomerView */.I, {
                                                    cookieEntityQr: entityQr
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/client-opd.tsx






var ClientOpd = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var cookiePhoneNumber = cookies.qme ? cookies.qme["phone"] : null;
    var cookieQr = cookies.qme ? cookies.qme["qr"] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "QMe - Doctor' Patient management"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "QMe - Patient management system"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "opd management software"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientIndependentOpdView, {
                        cookiePhoneNumber: cookiePhoneNumber,
                        cookieQr: cookieQr,
                        qmeEnabled: true
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var client_opd = (ClientOpd);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2770,4885,9669,7847,8298,2584,6354,1074,4996,9198,2541,8890,7003,5009,1192,2390,9211,1843,5585,5451,8013,9774,2888,179], function() { return __webpack_exec__(62421); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);